import { useEffect,  useState } from "react";
import {
  MaterialReactTable,

} from "material-react-table";
import { base_url } from "../../config";
import axios from "axios";


 const Workshops = ({ws}) => {


    const [global, showGlobal] = useState(true);
    const [wsShown, setWsShown] = useState(null);
    const [wsParticipants, setWsParticipants] = useState([]);
    const [loading, setLoading] = useState(false);

    const selectWorkshop = (row) => {
      setWsShown(row.id);
      showGlobal(false);
    };

    const goBack = () => {
      setWsShown(null);
      setWsParticipants([]);
      showGlobal(true);
    };

    
      const handleDownload = async (ws_code, which) => {
        
        
        try {
          const response = await axios.post(
            `${base_url}/api/admin/export_ws_participants/${ws_code}/${which}`, // Adjust the endpoint as needed    
            { title: `Workhsop attendees ${ws_code}` },
            { responseType: "blob" }
          );
          const pdfBlob = new Blob([response.data], { type: "application/xlsx" });
    
          const url = window.URL.createObjectURL(pdfBlob);
          const tempLink = document.createElement("a");
          tempLink.href = url;
          tempLink.setAttribute("download", `Workshop attendees ${ws_code}.xlsx`); // Set the desired filename for the downloaded file
    
          // Append the <a> element to the body and click it to trigger the download
          document.body.appendChild(tempLink);
          tempLink.click();
    
          // Clean up the temporary elements and URL
          document.body.removeChild(tempLink);
          window.URL.revokeObjectURL(url);
         
        } catch (error) {
          console.error("Error downloading report: ", error);
          alert("Failed to download report. Please try again later.");
        }
      };

    useEffect(() => {
      const fetchParticipants = async () => {
        if (wsShown) {
          setLoading(true);
          try {
            const response = await axios.get(
              `${base_url}/api/admin/get_ws_participants/${wsShown}`
            );
            setWsParticipants(response.data);
          } catch (error) {
            console.error("Error fetching participants:", error);
          } finally {
            setLoading(false);
          }
        }
      };

      fetchParticipants();
    }, [wsShown]);

    const columnsGlobal = [
      {
        accessorKey: "workshop_code",
        header: "Code",
        maxSize: 100,
      },
      {
        id: "title",
        accessorKey: "title",
        header: "Title",
        size: 500, // Make title column wider
        minSize: 500,
      },
      {
        id: "attendees",
        accessorKey: "attendees",
        header: "Attendees",
        maxSize: "50px",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return <div className="text-center font-bold">{value}</div>;
        },
      },
      {
        id: "attendees_in_progress",
        accessorKey: "attendees_in_progress",
        header: "In progress",
        maxSize: 50,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return <div className="text-center text-gray-500">{value}</div>;
        },
      },
      {
        id: "actions",
        accessorKey: "actions",
        header: "Actions",

        Cell: ({ cell }) => {
          const row = cell.row.original; // Get the entire row data
          return (
            <div className="flex flex-row gap-2 justify-center">
              <button
                className="bg-blue-500 text-xs text-white px-3 py-1 rounded text-sm hover:bg-blue-600 transition-colors"
                onClick={() => selectWorkshop(row)}
              >
                View
              </button>
              <button
                className="bg-cyan-500 text-xs text-white px-3 py-1 rounded text-sm hover:bg-cyan-600 transition-colors"
                onClick={() => handleDownload(row.workshop_code, "all")}
              >
                Export (All)
              </button>
              <button
                className="bg-cyan-500 text-xs text-white px-3 py-1 rounded text-sm hover:bg-cyan-600 transition-colors"
                onClick={() => handleDownload(row.workshop_code, "consent")}
              >
                Export (Consent)
              </button>
            </div>
          );
        },
      },
    ];

    const columnsParticipants = [
      {
        id: "registration_id",
        accessorKey: "registration_id",
        header: "Registration ID",
        maxSize: 50,
      },
      {
        accessorKey: "name",
        header: "Name",
      },
      {
        accessorKey: "email",
        header: "email",
      },
      {
        accessorKey: "max_step",

        header: "Status",
        Cell: ({ cell }) => {
          const value = cell.getValue();
          if (value === "Confirmation") {
            return <div className="font-bold text-blue-800">Completed</div>;
          }
          return <div className="text-yellow-500">In progress</div>;
        },
      },
    ];
    if (loading) {
        return (
            <div className="flex justify-center items-center h-full">
                <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500"></div>
            </div>
        );
    }
    return (
      <>
        
        <div>
          {global ? (
            <>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">All workshops</h2>
              </div>
            </>
          ) : (
            <>
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">
                  {ws.filter((i) => i.id === wsShown)[0].workshop_code}:{" "}
                  {ws.filter((i) => i.id === wsShown)[0].title}
                </h2>
                <button
                  className="bg-gray-500 text-white px-3 py-1 rounded text-sm hover:bg-gray-600 transition-colors"
                  onClick={() => goBack()}
                >
                  Back to all workshops
                </button>
              </div>
            </>
          )}
          <div style={{ display: global ? "block" : "none" }}>
            <MaterialReactTable
              data={ws}
              columns={columnsGlobal}
             
            />
          </div>
          <div style={{ display: global ? "none" : "block" }}>
            <MaterialReactTable
              data={wsParticipants}
              columns={columnsParticipants}
            />
          </div>
        </div>
      </>
    );
  };

  export default Workshops;